import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "description-item" }
const _hoisted_2 = { class: "value" }



  
export default /*@__PURE__*/_defineComponent({
  __name: 'DesciptionItem',
  props: {
    label: {},
    value: {},
    size: { default: 4 },
    space: { default: '8px' }
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "label",
      style: _normalizeStyle({
        width: `${_ctx.size}em`,
        'margin-right': `${_ctx.space}`,
      })
    }, _toDisplayString(_ctx.label), 5),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.value), 1)
      ])
    ])
  ]))
}
}

})